import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { TalentPoolsBriefEffects } from './talent-pool/talent-pool-brief.effects';
import {
  TalentPoolsBriefNamespace,
  TalentPoolsBriefReducer,
} from './talent-pool/talent-pool-brief.store';
import { TalentPoolsEffects } from './talent-pool/talent-pool.effects';
import { TalentPoolsNamespace, TalentPoolsReducer } from './talent-pool/talent-pool.store';
import { TalentPoolsByCompanyEffects } from './talent-pools-by-company/talent-pools-by-company.effects';
import {
  TalentPoolsByCompanyNamespace,
  TalentPoolsByCompanyReducer,
} from './talent-pools-by-company/talent-pools-by-company.store';

@NgModule({
  imports: [
    EffectsModule.forFeature([
      TalentPoolsBriefEffects,
      TalentPoolsEffects,
      TalentPoolsByCompanyEffects,
    ]),
    StoreModule.forFeature(TalentPoolsNamespace, TalentPoolsReducer),
    StoreModule.forFeature(TalentPoolsBriefNamespace, TalentPoolsBriefReducer),
    StoreModule.forFeature(TalentPoolsByCompanyNamespace, TalentPoolsByCompanyReducer),
  ],
})
export class TalentPoolsDataModule {}
